import Vue from 'vue'
import Vuex from 'vuex'
// import api from '@/api/onlineSchool'
import createPersistedState from "vuex-plugin-persistedstate"

Vue.use(Vuex)
// 3. 创建 Store 的实例对象
let defaultOrgid = null
let defaultWebInfo = null
try {
  if (JSON.parse(localStorage.org_id)) {
    defaultOrgid = localStorage.org_id
  }
} catch (e) { }
try {
  if (JSON.parse(localStorage.webInfo)) {
    defaultWebInfo = JSON.parse(localStorage.webInfo)
  }
} catch (e) { }
const modules = {}
const require_module = require.context('./modules', false, /.js$/)
require_module.keys().forEach(file_name => {
  modules[file_name.slice(2, -3)] = require_module(file_name).default
})

const store = new Vuex.Store({
  modules: modules,
  state: {
    org_id: defaultOrgid,
    webInfo: defaultWebInfo,
    domain: ''
  },
  plugins: [createPersistedState({
    paths: ['course']
  })],
  getters: {
    getWebInfo(state) {
      return state.webInfo
    }
  },
  mutations: {
    saveOrg_id(state, payLoad) {
      this.state.org_id = payLoad
    },
    saveWebInfo(state, payLoad) {
      state.webInfo = payLoad
    },
    saveDomain(state, payLoad) {
      state.domain = payLoad
    }
  },
  actions: {
    
    getOrgID({ commit }, payLoad) {
      return new Promise((resolve, reject) => {
        const data = {
           domain: payLoad
          // domain: 'wx-aboh.tengface.cn'
          // domain: 'wx-adia.shanhuketang.com'
        }
        Vue.prototype.$axios.post('/common/index/getOrgInfo', data).then(res => {
          if (res.data.code === 200 && res.data.data) {
            commit('saveOrg_id', res.data.data.uid)
            commit("user/setOrgID", res.data.data.uid)
            commit("user/setIsShanhuState", res.data.data.is_shanhu)
            localStorage.setItem('tengface_org_id', res.data.data.uid)
            localStorage.setItem('tengface_is_show', res.data.data.is_show)
            localStorage.setItem('tengface_is_shanhu', res.data.data.is_shanhu)
            resolve(res.data.data)
          } else if(res.data.code === 10000){
            // 校验机构状态是否正常
            Vue.prototype.$confirm('该机构已被禁用，直播相关功能限制使用', '提示', {
              showClose: false,
              showConfirmButton: false,
              showCancelButton: false,
              closeOnClickModal: false,
              type: 'error'
            })
          }
        })
      }
      )
    },
    //获取商户网站的信息
    getWebInfo({ commit }, payLoad) {
      return new Promise((resolve, reject) => {
        const data = {
          key: payLoad
          // wx-adia.shanhuketang  wx-bgfccdib.shanhuketang
          // key: 'kt.houlangxuexi.com'
        }
        Vue.prototype.$axios.get('/common/index/getWebBaseInfo', { params: data }).then(res => {
          if (res.data.code === 200) {
            if (location.host.indexOf('tengface.cn') == -1) { //默认
              if (!res.data.data.web_bottom_logo) {
                res.data.data.web_bottom_logo = 'https://tengface-live-user-1308721187.cos.accelerate.myqcloud.com/uploads/1491/2023/08/18/imrMCpCx_logo-04.png'
              }
              if (!res.data.data.web_header_logo) {
                res.data.data.web_header_logo = 'https://tengface-live-user-1308721187.cos.accelerate.myqcloud.com/uploads/1491/2023/08/18/imrMCpCx_logo-04.png'
              }
              if (!res.data.data.web_header_icon) {
                res.data.data.web_header_icon = 'https://tengface-live-user-1308721187.cos.accelerate.myqcloud.com/uploads/1491/2023/08/18/nQbWH46s_logo-05.png'
              }
              if (!res.data.data.web_company_name) {
                res.data.data.web_company_name = '珊瑚课堂'
              }
            }
            commit('saveWebInfo', res.data.data)
            localStorage.setItem('webInfo', JSON.stringify(res.data.data))
            resolve(res.data.data)
          } else {
            reject()
          }
        })
      }
      )
    },
  }
})

// 4. 向外共享 Store 的实例对象
export default store
